import { styled, Box } from '../../../../base';

export const StyledCard = styled(Box)(({ theme }) => ({
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 12,
    padding: theme.spacing(2, 2.5),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flex: '1 1 0',
    minWidth: 250,
}));

export const StyledDonutWrapper = styled(Box)({
    position: 'relative',
    width: 120,
    height: 120,
    flexShrink: 0,
});

export const StyledCenterLabel = styled(Box)({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
});

export const StyledTrendRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
}));
